import { isGeoPointInGeoPolygon } from "@daytrip/utils";
import type { ValidationArguments, ValidatorConstraintInterface } from "class-validator";
import { ValidatorConstraint } from "class-validator";

import type { MeetingPosition } from "../models/MeetingPosition";

@ValidatorConstraint({ name: "Is position outside of restricted area polygon" })
export class IsPositionOutsideOfRestrictedAreaPolygon implements ValidatorConstraintInterface {
    public validate(value: any, validationArguments: ValidationArguments): boolean {
        const { restrictedAreaPolygon } = validationArguments.object as MeetingPosition;
        if (!restrictedAreaPolygon) {
            return true;
        }

        return !isGeoPointInGeoPolygon(value, restrictedAreaPolygon.coordinates[0]);
    }

    public defaultMessage(): string {
        return "Position must be located outside of restricted area polygon.";
    }
}
